import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary, useToken } from '@ant-design/pro-utils';
import { Layout } from 'antd';
import classNames from 'classnames';

var WrapContent = function WrapContent(props) {
  var _classNames;

  var _useToken = useToken(),
      hashId = _useToken.hashId;

  var style = props.style,
      prefixCls = props.prefixCls,
      children = props.children,
      hasPageContainer = props.hasPageContainer;
  var contentClassName = classNames("".concat(prefixCls, "-content"), hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-has-header"), props.hasHeader), _defineProperty(_classNames, "".concat(prefixCls, "-content-has-page-container"), hasPageContainer), _classNames));
  var ErrorComponent = props.ErrorBoundary || ErrorBoundary;
  return props.ErrorBoundary === false ? _jsx(Layout.Content, {
    className: contentClassName,
    style: style,
    children: children
  }) : _jsx(ErrorComponent, {
    children: _jsx(Layout.Content, {
      className: contentClassName,
      style: style,
      children: children
    })
  });
};

export { WrapContent };